import { useAuth } from '@/contexts/AuthContext';
import { PixelQuotaDisplayComponent } from './PixelQuotaDisplay.component';

interface PixelQuotaDisplayProps {
  pendingPixelsCount?: number;
  pendingPixelsNeedingQuota?: number;
  shouldFlash?: boolean;
  onFlashComplete?: () => void;
}

export const PixelQuotaDisplay: React.FC<PixelQuotaDisplayProps> = ({
  pendingPixelsCount = 0,
  pendingPixelsNeedingQuota = 0,
  shouldFlash = false,
  onFlashComplete,
}) => {
  const { user } = useAuth();

  return (
    <PixelQuotaDisplayComponent
      user={user}
      pendingPixelsCount={pendingPixelsCount}
      pendingPixelsNeedingQuota={pendingPixelsNeedingQuota}
      shouldFlash={shouldFlash}
      onFlashComplete={onFlashComplete}
    />
  );
};

